import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SimpleSelectFieldComponent } from './simple-select-field.component';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';

@NgModule({
  declarations: [SimpleSelectFieldComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatTooltipModule,
    FieldErrorMessagesModule,
  ],
  exports: [SimpleSelectFieldComponent],
})
export class SimpleSelectFieldModule {}
